// extracted by mini-css-extract-plugin
export default {"backdrop":"_1Hzf3Xci","light":"_129Qh_F5"};